<template>
  <header>
    <div class="mobile-fix-option"></div>
    <nav class="navbar navbar-expand-lg navbar-dark froot-navbar">
      <router-link :to="{ path: '/shop'}">
        <img :src="require('@/assets/images/' + logo)" class="hppc_white_logo" alt="logo" />
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <template v-if="!signedIn">
            <li>
              <router-link class="nav-link" :to="{ path: '/login' }">Sign In</router-link>
            </li>
          </template>
          <template v-if="signed_in_as_web_user && signedIn">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/shop' }">Menu</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/rewards' }">Rewards</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/account/main' }">My Account</router-link>
            </li>
          </template>
        </ul>
        <form class="text-center my-2 my-lg-0">
          <router-link class="nav-link shopping-cart-link" :to="{ path: '/shop/cart' }">
            <img :src='"@/assets/images/union.svg"' class="shopping-cart" alt="shopping cart" width="32" />
            <h3 class="mt-1 mb-0 text-white" v-if="cart && cart.items.length">$ {{ cart.total_usd }}</h3>
          </router-link>
        </form>
      </div>
    </nav>
  </header>
</template>
<script>

import { mapGetters } from "vuex";

export default {
  data() {
   return {
     logo: "LFB_menu_logo.svg"
   };
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      signed_in_as_web_user:'auth/webUserAuthed',
      cart: 'cart/getCart',
    })
  }
}
</script>
